import { render, staticRenderFns } from "./Tips.vue?vue&type=template&id=cf3325a0&scoped=true"
var script = {}
import style0 from "./Tips.vue?vue&type=style&index=0&id=cf3325a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3325a0",
  null
  
)

export default component.exports